export default "__VITE_ASSET__113bafd9__"